import { createFileRoute } from '@tanstack/react-router';
import { loadShire, makeShireSubPageHead, type ShireLoaderData } from '../components/shared/shire-sub-route';
import { ShireSubPageShell } from '../components/shared/ShireSubPageShell';
import {
  CommonCouncilServicesSection,
  CouncilMeetingsSection,
  PostOfficesSection,
} from '../components/shared/ShireInlineSections';

export const Route = createFileRoute('/shire/$name_/council')({
  loader: ({ params }) => loadShire(params.name),
  head: (ctx) =>
    makeShireSubPageHead(
      (ctx as { loaderData?: ShireLoaderData } | undefined)?.loaderData,
      'Council',
      'Rates, bins and waste, roads and footpaths, building and planning, council meetings and post offices.',
    ),
  component: CouncilPage,
});

function CouncilPage() {
  const { shire } = Route.useLoaderData() as ShireLoaderData;
  return (
    <ShireSubPageShell
      shire={shire}
      eyebrow="Council"
      title="Council services"
      lede={`Rates, bins, roads, planning, meetings and post offices for the Shire of ${shire.name}.`}
    >
      <CommonCouncilServicesSection shire={shire} />
      <CouncilMeetingsSection shire={shire} />
      <PostOfficesSection shire={shire} />
    </ShireSubPageShell>
  );
}
